import { ref } from 'ember-ref-bucket';
import { getGreetingTime } from 'volta/utils/date-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

// @ts-ignore
import type MediaService from 'ember-responsive';
import type SessionService from 'ember-simple-auth/services/session';
import type AppNavState from 'volta/services/app-nav-state';
import type SessionUserService from 'volta/services/session-user';
import type BvMetricsService from 'volta/services/bv-metrics';
import type StoreService from 'volta/services/store';
import type LocalPreferencesService from 'volta/services/local-preferences';
import type DashboardStatsService from 'volta/services/dashboard-stats';
import type AppSettings from 'volta/services/app-settings';
export default class BvApp extends Component<{}> {
  @service appNavState!: AppNavState;
  @service media!: MediaService;
  @service sessionUser!: SessionUserService;
  @service bvMetrics!: BvMetricsService;
  @service store!: StoreService;
  @service localPreferences!: LocalPreferencesService;
  @service session!: SessionService;
  @service dashboardStats!: DashboardStatsService;
  @service appSettings!: AppSettings;

  @ref('appContent') appRef!: HTMLElement;
  clickOutsideEvtHandler?: () => void;

  get mobileView(): boolean {
    return this.media.isMobile as boolean;
  }

  get tabIndex() {
    return this.mobileView ? 0 : -1;
  }

  get menuItems() {
    return this.appNavState.content.filter((item) => item.hidden !== true);
  }

  get greeting() {
    return getGreetingTime();
  }

  get loadingPercentFormatted() {
    const { loading } = this.appNavState;
    return loading ? `${loading * 100}%` : 0;
  }

  @action
  updateAppListener() {
    const { navIsExpanded } = this.appNavState;
    if (navIsExpanded && !this.clickOutsideEvtHandler) {
      this.clickOutsideEvtHandler = () => this.appNavState.collapse(true);
      this.appRef.addEventListener('click', this.clickOutsideEvtHandler);
    } else if (!navIsExpanded && this.clickOutsideEvtHandler) {
      this.appRef.removeEventListener('click', this.clickOutsideEvtHandler);
      this.clickOutsideEvtHandler = undefined;
    }
  }

  @action
  async logout() {
    this.bvMetrics.trackAction(this, 'logout', this.sessionUser.user?.login);
    let url: string;
    try {
      url = await this.store.normalPost('sessions/logout');
    } finally {
      await this._onLogoutSuccess();
    }

    // In most case logout don't return an url
    // But with Okta we also need to logout of the Okta application ( The logout only works with redirection)
    // So if a url is return, we redirect to the url
    // And when the external logout is completed, it should return us to the login form
    if (url) {
      window.location.replace(url);
    }
  }

  async _onLogoutSuccess() {
    this.localPreferences.clear();
    await this.session.invalidate();
    this.bvMetrics.cleanup();
  }
}
